(ns hypnos.time
  "Date and time functions."
  #?(:clj (:require [java-time :as jt])
     :cljs (:require [cljs-time.core :as ct]
                     [cljs-time.format :as cf])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

(def MMM-d-YYYY "MMM d, YYYY")
(def MM-dd-YYYY-HH-MM-SS "MM/dd/YYYY @ hh:mm A")
(def YYYY-MM-DDTHH-MM-SS-NNN "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
(def MMM-d-YYYY-HH-MM-SS-TZ "MMM dd, YYYY @ hh:mm A")

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

#?(:clj
   (do
     (defn- local-date->instant
       "Convert local-date to instant/java-date (assuming UTC)."
       [ld]
       (jt/to-java-date (jt/zoned-date-time ld (jt/local-time 0) "UTC")))

     (defn- instant->local-date
       "Convert instant/java-date to local-date (assuming UTC)."
       [i]
       (jt/local-date i "UTC"))
     ))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

;;
;; period stuff
;;

(defn days
  "Returns days period."
  [n]
  #?(:clj (jt/days n)
     :cljs (ct/days n)))

;;
;; datetime stuff
;;

(defn now
  "Get the current instant in UTC"
  []
  #?(:clj  (jt/to-java-date (jt/instant))
     :cljs (ct/now)))

(defn date?
  "Returns true if o is a date."
  [o]
  #?(:clj (inst? o)
     :cljs (cljs-time.core/date? o)))

(defn before?
  "Returns true if 'dt1' is strictly before 'dt2'."
  [dt1 dt2]
  #?(:clj (jt/before? (instant->local-date dt1) (instant->local-date dt2))
     :cljs (ct/before? dt1 dt2)))

(defn plus
  "Returns a new date/time corresponding to the given date/time moved forwards by
  the given period."
  [dt period]
  #?(:clj (-> (instant->local-date dt)
              (jt/plus period)
              (local-date->instant))
     :cljs (ct/plus dt period)))

;;
;; conversions
;;

(defn to-aws-date
  "Convert date to AWSDate."
  [d]
  #?(:clj  (jt/format (jt/formatter :iso-local-date)
                      (jt/zoned-date-time d "UTC"))
     :cljs (cf/unparse (cf/formatters :date) d)))

(defn from-aws-date
  "Consert AWSDate to date."
  [s]
  #?(:clj (local-date->instant (jt/local-date (jt/formatter :iso-local-date) s))
     :cljs (cf/parse (cf/formatters :date) s)))

(defn to-aws-date-time
  "Convert datetime to AWSDate."
  [dt]
  #?(:clj  (jt/format (jt/formatter YYYY-MM-DDTHH-MM-SS-NNN)
                      (jt/zoned-date-time dt "UTC"))
     :cljs (cf/unparse (cf/formatters :date-time) dt)))

(defn from-aws-date-time
  "Consert AWSDateTime to datetime."
  [s]
  #?(:clj (jt/to-java-date (jt/instant (jt/formatter :iso-instant) s))
     :cljs (cf/parse (cf/formatters :date-time) s)))

(defn format-date
  [pattern d]
  (when d
    #?(:clj  (jt/format pattern d) ;; TODO Test that this works
       :cljs (cf/unparse (cf/formatter pattern) d))))

#?(:cljs

   (defn to-default-time-zone
     "Converts the datetime to the default timezone."
     [dt]
     (cljs-time.core/to-default-time-zone dt))

   )
